import {
  GET_GOOGLE_RECAPTCHA_TOKEN,
  GET_GOOGLE_RECAPTCHA_TOKEN_ERROR,
  GET_GOOGLE_RECAPTCHA_TOKEN_SUCCESS,
  VERIFY_GOOGLE_RECAPTCHA_TOKEN,
  VERIFY_GOOGLE_RECAPTCHA_TOKEN_ERROR,
  VERIFY_GOOGLE_RECAPTCHA_TOKEN_SUCCESS
} from './Recaptcha.actions'

const recaptchaState = {
  error: undefined,
  gettingToken: false,
  hostName: '',
  score: '',
  verifyingToken: false
}

/**
 * The Recaptcha's reducer.
 */
const recaptchaReducer = (state = recaptchaState, { payload, type }) => {
  switch (type) {
    case GET_GOOGLE_RECAPTCHA_TOKEN: {
      return {
        error: undefined,
        ...state,
        gettingToken: true
      }
    }
    case GET_GOOGLE_RECAPTCHA_TOKEN_SUCCESS: {
      return {
        ...state,
        error: undefined,
        gettingToken: false,
        hostName: '',
        score: ''
      }
    }
    case GET_GOOGLE_RECAPTCHA_TOKEN_ERROR: {
      return {
        ...state,
        error: payload.error,
        gettingToken: false
      }
    }
    case VERIFY_GOOGLE_RECAPTCHA_TOKEN: {
      return {
        ...state,
        error: undefined,
        hostName: '',
        score: '',
        verifyingToken: true
      }
    }
    case VERIFY_GOOGLE_RECAPTCHA_TOKEN_SUCCESS: {
      return {
        ...state,
        error: undefined,
        hostName: payload.hostName,
        score: payload.score,
        verifyingToken: false
      }
    }
    case VERIFY_GOOGLE_RECAPTCHA_TOKEN_ERROR: {
      return {
        ...state,
        error: payload.error,
        verifyingToken: false
      }
    }
    default: {
      return state
    }
  }
}

export default recaptchaReducer
